export default __webpack_public_path__ + "static/media/delivery-box-operation-02.18ef9c5e.png";